import React, { Component } from "react";
import { FormGroup, Alert, Label, Button, FormFeedback, Input, Row, Col, Spinner } from "reactstrap";
import ImageCropModal from "../ImageCropModal/ImageCropModal";
import Form from "./../../../general/Form/Form";

import axios from "axios";
import blobify from "../../drive/TruckForm/TruckImageBlobifier";

import classes from '../../placeholderTrucks/EditPlaceholderModal/EditPlaceholderModal.module.scss'
import { boxiPrimary, boxiRed } from "../../../../assets/style/colors";



class ClientUserForm extends Component {
  state = {
    invalidEmail: false,
    toastHeader: "",
    toastBody: "",
    isToastOpen: false,
    isLoading: false,
    name: '',
    email: '',
    company: '',
    password: '',
    imageUploadLoading: false,
    userProfileUrl: '',
    invalidPicture: false,
    disableSaveButton: false
  };

  disableTheButton = (value) => {
    this.setState({
      disableSaveButton: value
    })
  }

  setInvalidProfileError = () => {
    this.setState({
      invalidPicture: false
    })
  }

  onFormSubmitHandler = (e) => {
    e.preventDefault();
    this.setState({
      invalidEmail: false,
      isLoading: true
    });

    let email = this.state.email;
    if(this.state.userProfileUrl === ''){
      this.setState({
        invalidPicture: true,
        isLoading: false
      })
      return;
    }
    if (email) {
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true
      };
      const data = {
        name: this.state.name,
        email: email,
        company: this.state.company,
        privilege_id: 4,
        password: this.state.password,
        userProfileUrl: this.state.userProfileUrl.length > 0 ? this.state.userProfileUrl: null
      };
      axios
        .post(`${process.env.REACT_APP_API_HOST}/user/client`, data, config)
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              isLoading: false,
              name: '',
              email: '',
              company: '',
              password: '',
              toastHeader: 'Success',
              toastBody: `A new client user was created.`,
              isToastOpen: true,
              userProfileUrl: ''
            })

            this.props.refresh();
            setTimeout(() => {
              this.setState({
                isToastOpen: false
              })
            }, 3000);
          }
        })
        .catch((error) => {
          this.setState({
            toastHeader: 'Failure',
            toastBody: 'There was a problem creating client user!',
            isToastOpen: true
          })
          setTimeout(() => {
            this.setState({
              isToastOpen: false
            })
          }, 3000);
          console.log(error);
        });
    }
    if (!email) {
      this.setState({
        invalidEmail: true
      });
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleImageUpload = async (selectedImage) => {
    this.setState({
      imageUploadLoading: true,
      invalidPicture: false
    })
    if (selectedImage) {
      try {
        const blob = new Blob([selectedImage], { type: selectedImage.type });
        const formData = new FormData();
        this.setState({
         disableSaveButton: true 
        })
        formData.append("image", blob, selectedImage.name);
        const res = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_HOST}/user/upload-media`,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (res?.data?.uploaded_image) {
          this.setState({
            userProfileUrl: res?.data?.uploaded_image,
            imageUploadLoading: false,
            disableSaveButton: false
          })
        } else {
          this.setState({
            userProfileUrl: '',
            imageUploadLoading: false,
            disableSaveButton: false
          })
        }
      } catch (error) {
        console.log(error);
        this.setState({
          userProfileUrl: '',
          imageUploadLoading: false,
          disableSaveButton: false
        })
      }
    }


  };
  render() {
    const style = {
      padding: "15px 0px"
    };

    
    return (
      <>
        {this.state.toastHeader === 'Success' && this.state.isToastOpen &&
          <Alert className={classes.alertMsg}>
            {this.state.toastBody}
          </Alert>
        }
        {this.state.toastHeader === 'Failure' && this.state.isToastOpen &&
          <Alert className={classes.alertMsg} color="danger">
            {this.state.toastBody}
          </Alert>
        }
        <Form
          onSubmit={this.onFormSubmitHandler}
          title="Create New Client User"
          formStyle={style}
          >
          {/* <input type="hidden" value="this is required to turn off auto complete in chrome for some reason" /> */}
          <Row form className="mb-4">
            <Col xs={12} className="pl-5 pr-5">
              <FormGroup>
          {this.state.invalidPicture ? <p style={{color: boxiRed, display: 'flex', justifyContent: 'center'}}>Picture is required</p> : ''}
                <div className={classes.image_upload}>
                         <ImageCropModal userProfileUrlModal={this.state.userProfileUrl} setInvalidProfileError={this.setInvalidProfileError} classes={classes} disableTheButton={this.disableTheButton} handleImageUpload={this.handleImageUpload}/>
                      {/* {!this.state.imageUploadLoading && this.state.userProfileUrl === '' ? (

                      ) : this.state.imageUploadLoading && this.state.userProfileUrl === '' ? (
                        <div style={{
                          height: '100px',
                          width: '100px',
                          display: 'flex',
                          color: '#fff',
                          justifyContent: 'center',
                          borderRadius: '50%',
                          alignItems: 'center',
                          background: 'rgb(204, 204, 204)',
                        }}>
                          <Spinner
                          style={{ width: "1.2rem", height: "1.2rem" }}
                          type="border"
                          color="light"
                          className="spinner-border-sm"
                        />
                        </div>
                      ) : !this.state.imageUploadLoading && this.state.userProfileUrl !== '' ? (
                        <img 
                        style={{
                          height: '100px',
                          width: '100px',
                          borderRadius: '50%',
                        }}
                        src={this.state.userProfileUrl} 
                        alt="client uploaded image" />
                      ) : (
                        <></>
                      )} */}
                </div>
              </FormGroup>
            </Col>
            <Col xs={6} className="pl-5 pr-5">
              <FormGroup>
                <Label for="clientName">Name</Label>
                <Input
                  autoComplete="new-password"
                  type="text"
                  name="name"
                  id="clientName"
                  placeholder="Client's name"
                  value={this.state.name}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label for="clientEmail">Email</Label>
                <Input
                  autoComplete="new-password"
                  type="email"
                  name="email"
                  id="clientEmail"
                  placeholder="Client's email"
                  invalid={this.state.invalidEmail}
                  value={this.state.email}
                  onChange={this.handleChange}
                />
                <FormFeedback>Client user must have an email.</FormFeedback>
              </FormGroup>
            </Col>
            <Col xs={6} className="pl-5 pr-5">
              <FormGroup>
                <Label for="clientCompany">Company</Label>
                <Input
                  type="text"
                  name="company"
                  id="clientCompany"
                  placeholder="Client's company"
                  value={this.state.company}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label for="clientDefaultPassword">Default Password</Label>
                <Input
                  type="text"
                  name="password"
                  id="clientDefaultPassword"
                  placeholder="Set a default password"
                  value={this.state.password}
                  onChange={this.handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form className="mb-4">
            <Col xs={6} className="pl-5 pr-5">
              <Button disabled={this.state.disableSaveButton} style={{ backgroundColor: boxiPrimary, borderColor: boxiPrimary }}>
                {this.state.isLoading ?
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Spinner
                      style={{ width: "1.2rem", height: "1.2rem" }}
                      type="border"
                      color="light"
                      className="spinner-border-sm"
                    />
                  </div>
                  :
                  <span>Create User</span>
                }
              </Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  }
}

export default ClientUserForm;
